import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import _ from "lodash";
import styled, { css } from "styled-components";

import QuestionnairesApi from "../../../api/questionnaires-api";
import ModalsService from "../../../services/modals-service";
import { EModals } from "../../../types/enums";
import EditQuestionnaireModal from "../../modals/edit-questionnaire-modal";
import { ELabTabStatus, LabTab, NotFoundWrapper } from "../labs-page";

import { Breadcrumb, Button, Container, Frame, RowWrapper, TExtra } from "components/ui-kit/styled-templates";

import Sidebar from "arui-feather/sidebar";

import useBodyBackground from "hooks/useBodyBackground";
import { useStorageListener } from "hooks/useStorage";
import axios from "axios";
import CommonHelper from "../../../services/common-service";

import moment from "moment";
import Select from "react-select";
import * as XLSX from "xlsx";

const AdminQuestionnairesPage = () => {
    const { t } = useTranslation();

    // const { params } = useQueryParams();
    // const { universityId } = params;
    // const navigate = useNavigate();
    useBodyBackground("white");
    const [selectedResultsId, setSelectedResultsId] = useState(undefined);
    const [results, setResults] = useState([]);

    const [isLastDay, setIsLastDay] = useState(false);
    const [filterType, setFilterType] = useState(undefined);

    useEffect(() => {
        if (selectedResultsId == undefined) {
            return;
        }
        axios.get(`/questionnaire/${selectedResultsId}/formatted-answers`).then(d => d.data).then(arr => {
            setResults(arr);
        });
    }, [selectedResultsId]);

    const questionnaires = useStorageListener((state) => _.values(state?.questionnaires));
    let selQ = (questionnaires.filter(xx => (xx.id == selectedResultsId)))[0];

    const handlers = {
        createQuestionnaire: () => {
            ModalsService.showModal(EModals.CreateQuestionnaire, { mode: `create` });
        },
        editQuestionnaire: (id: string) => () => {
            ModalsService.showModal(EModals.CreateQuestionnaire, {
                mode: `edit`,
                data: _.find(questionnaires, { id })
            });
        },
        onResultsClick: (id: string) => () => {
            console.log("--->> onResultsClick: id = ", id);
            setSelectedResultsId(id);
        },
        deleteQuestionnaire: (id: string) => async () => {
            ModalsService.showModality({
                title: `Удаление опросника`,
                description: `Вы уверены, что хотите удалить опросник "${_.find(questionnaires, { id })?.details?.name ?? `без названия`}"?`,
                cancelButton: {
                    children: `Отмена`,
                    background: `gray`,
                    onClick: () => {
                    }
                },
                confirmButton: {
                    children: `Удалить`,
                    background: `red`,
                    // onClick: async () => await QuestionnairesApi.deleteQuestionnaire(id),
                    onClick: () => {
                        QuestionnairesApi.deleteQuestionnaire(id);
                    }
                }
            });
        }
    };

    // @ts-ignore
    useEffect(QuestionnairesApi.getQuestionnaires, []);

    let filteredQuestionnaires = questionnaires;
    if (isLastDay == true) {
        filteredQuestionnaires = filteredQuestionnaires.filter(xx => (xx.timestamp > +moment().startOf("day")));
    }
    if (filterType != undefined) {
        filteredQuestionnaires = filteredQuestionnaires.filter(xx => ((xx?.details?.role || 'user') == filterType));
    }

    return (
        <Container extra="padding-top: 10px; align-items: flex-start;">
            {/*<Row extra="gap: 15px;">*/}
            {/*    {universityId && (*/}
            {/*        <DormitoryTab.Link color="blue" direction="left" onClick={() => navigate(-1)}>*/}
            {/*            Назад*/}
            {/*        </DormitoryTab.Link>*/}
            {/*    )}*/}
            {/*    <h2>Опросники</h2>*/}
            {/*</Row>*/}

            <EditQuestionnaireModal />

            <Container extra={`align-items: flex-start;`}>
                <Breadcrumb.Wrapper>
                    <Breadcrumb.Item to="/">{t("4ihk6xecpxu")}</Breadcrumb.Item>
                </Breadcrumb.Wrapper>
                <RowWrapper extra={`h1 { margin: 0; };`}>
                    <h1>{t("hxsbj0a3dn7")}</h1>
                    <Button variant="outlined" onClick={handlers.createQuestionnaire}>
                        {t("gfg9rxr0lwv")}
                    </Button>
                </RowWrapper>

                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-start'}} >

                    <div style={{ marginTop: 30, marginRight: 40 }}>
                        <h3>
                            Группировка
                        </h3>
                        <h4 style={{ marginTop: 15 }}>
                            По дате:
                        </h4>
                        <ul>
                            <li style={{ fontWeight: (isLastDay == true) ? "bold" : "normal", cursor: "pointer" }}
                                onClick={() => {
                                    setIsLastDay(true);
                                }}>
                                за последний день
                            </li>
                            <li style={{ fontWeight: (isLastDay == false) ? "bold" : "normal", cursor: "pointer" }}
                                onClick={() => {
                                    setIsLastDay(false);
                                }}>
                                за все время
                            </li>
                        </ul>

                    </div>

                    <div style={{ marginTop: 30, marginBottom: 30 }}>
                        <h3>
                            Фильтр
                        </h3>
                        <h4 style={{ marginTop: 15 }}>
                            По типу:
                        </h4>
                        <ul>
                            <li style={{ fontWeight: (filterType == "uni-admin") ? "bold" : "normal", cursor: "pointer" }}
                                onClick={() => {
                                    if (filterType == "uni-admin") {
                                        setFilterType(undefined);
                                    } else {
                                        setFilterType("uni-admin");
                                    }
                                }}>
                                для вузов
                            </li>
                            <li style={{ fontWeight: (filterType == "user") ? "bold" : "normal", cursor: "pointer" }}
                                onClick={() => {
                                    if (filterType == "user") {
                                        setFilterType(undefined);
                                    } else {
                                        setFilterType("user");
                                    }
                                }}>
                                для путешественников
                            </li>
                        </ul>

                    </div>

                </div>

                <RowWrapper extra={`margin-top: 56px; flex-wrap: wrap; gap: 40px;`}>
                    {_.values(filteredQuestionnaires)?.map?.(({ details: item = {}, id }: any, index: any) => (
                        <QuestionnaireTab.Component key={index} {...{ item, id, handlers }} />
                    ))}
                </RowWrapper>
                {!_.values(filteredQuestionnaires).length && <NotFoundWrapper>{t("as51m0p6v9n")}</NotFoundWrapper>}
            </Container>


            <Sidebar visible={(selQ != undefined)} onCloserClick={() => {
                setSelectedResultsId(undefined);
            }}>
                {selQ == undefined ? null :
                    <div>

                        <h3>
                            {selQ?.details?.name}
                        </h3>
                        <p>
                            {selQ?.details?.question}
                        </p>

                        <MyTable style={{ marginTop: 20, width: "100%" }}>
                            <thead>
                            <MyTr>
                                <MyTd>
                                    <b>
                                        email
                                    </b>
                                </MyTd>
                                <MyTd>
                                    <b>
                                        ответ
                                    </b>
                                </MyTd>
                            </MyTr>
                            </thead>
                            <tbody>
                            {results.map((x, i) => {
                                return (
                                    <MyTr key={x?.user?.id}>
                                        <MyTd>
                                            {x?.user?.email}
                                        </MyTd>
                                        <MyTd>
                                            {x?.answer?.answer}
                                        </MyTd>
                                    </MyTr>
                                );
                            })}
                            </tbody>
                        </MyTable>

                        <div>
                            <span style={{ cursor: "pointer" }} onClick={() => {
                                // let csv = `email;ответ`;
                                // for (let i in results) {
                                //     let x = results[i];
                                //     csv = `${csv}\n${x?.user?.email};${x?.answer?.answer}`;
                                // }
                                // CommonHelper.downloadFile(`export_${moment().format("DD.MM.YYYY_HH_mm_ss")}.csv`, csv);

                                // let csvContent = "data:text/csv;charset=utf-8,";
                                // // csvContent += "data:text/csv;charset=utf-8,";
                                // csvContent += "email;ответ";
                                // csvContent += "\n";
                                // results.forEach((row) => {
                                //     csvContent += `${row?.details?.name};${row?.totalEventsNumber};${row?.doneVisitedNumber};${row?.doneNotVisitedNumber}`;
                                //     csvContent += "\n";
                                // });
                                // var encodedUri = encodeURI(csvContent);
                                // var link = document.createElement("a");
                                // link.setAttribute("href", encodedUri);
                                // link.setAttribute("download", "статистика.csv");
                                // document.body.appendChild(link); // Required for FF
                                // link.click();
                                const wb = XLSX.utils.book_new();
                                const ws = XLSX.utils.aoa_to_sheet([]);

                                // Adding headers to the worksheet
                                XLSX.utils.sheet_add_aoa(ws, [["email", "ответ"]]);

                                results.forEach(a => {

                                    XLSX.utils.sheet_add_aoa(ws, [[a?.user?.email, a?.answer?.answer]], { origin: -1 });
                                    // Adding each row of data to the worksheet
                                    // XLSX.utils.sheet_add_aoa(ws, [[unisMap[a.name], books.length, approvedBooks.length, rejectedBooks.length, newBooks.length, reviewBooks.length, canceledBooks.length, done_visitedBooks.length, done_not_visitedBooks.length]], { origin: -1 });
                                });

                                // Adding the worksheet to the workbook
                                XLSX.utils.book_append_sheet(wb, ws, "Questionnaire");

                                // Generate a CSV file and trigger download
                                XLSX.writeFile(wb, "questionnaire.xlsx");

                            }}>
                                экспорт
                            </span>
                        </div>

                    </div>
                }
            </Sidebar>

        </Container>
    );
};

export const QuestionnaireTab = {
    Component: (props: { item: any; id: string; handlers: { editQuestionnaire: Function; deleteQuestionnaire: Function, onResultsClick: Function } }) => {
        const { t } = useTranslation();
        const { item, id, handlers } = props;

        return (
            <LabTab.Wrapper>
                <LabTab.Name empty={_.isEmpty(item?.name)}>{item?.name ?? `Без имени`}</LabTab.Name>
                {/*<LabTab.Type>{EVENT_TYPES_OPTIONS?.find?.((i) => i?.value === item?.type)?.label}</LabTab.Type>*/}
                <LabTab.DetailsWrapper>
                    {/*<div>*/}
                    {/*    <div>Стоимость на 1 человека:</div>*/}
                    {/*    <strong>{item?.price} ₽</strong>*/}
                    {/*</div>*/}
                    {/*<div>*/}
                    {/*    <div>Даты проведения:</div>*/}
                    {/*    <strong>*/}
                    {/*        {moment(item?.dates?.from).format(`DD.MM`)} - {moment(item?.dates?.to).format(`DD.MM`)}*/}
                    {/*    </strong>*/}
                    {/*</div>*/}
                </LabTab.DetailsWrapper>
                {/*<Link to={`/labs/${id}`}>*/}
                {/*    <LabTab.Link color="blue">Предпросмотр</LabTab.Link>*/}
                {/*</Link>*/}
                <LabTab.Link color="blue" onClick={handlers.editQuestionnaire(id)}>
                    {t("0g6u40lcusr8")}
                </LabTab.Link>
                <LabTab.Link color="blue" onClick={handlers.onResultsClick(id)}>
                    Посмотреть результаты
                </LabTab.Link>
                <LabTab.Link color="red" onClick={handlers.deleteQuestionnaire(id)}>
                    {t("dajuq4gv3vo")}
                </LabTab.Link>
            </LabTab.Wrapper>
        );
    },
    Type: styled(Frame)`
      color: ${({ theme }) => theme.blue};
      font-size: 13px;
      line-height: 17px;
    `,
    Wrapper: styled(Frame)<{ status?: ELabTabStatus }>`
      width: calc(50% - 20px);
      padding: 24px 20px;
      box-sizing: border-box;
      border: 1px solid ${({ theme }) => theme.halfblue};
      border-radius: 8px;
      align-items: flex-start;
      justify-content: flex-start;
      gap: 10px 0;
      position: relative;

      > * {
        margin: 0;
      }

      @media (max-width: 991px) {
        width: inherit;
      }
    `,
    Name: styled.h3<{ empty: boolean; extra?: TExtra }>`
      color: ${({ theme, empty }) => (empty ? theme.text.light : theme.text.primary)};

      ${({ extra }) => extra}
    `,
    Link: styled(Frame)<{ color: `red` | `blue`; direction?: `right` | `left` }>`
      color: ${({ theme, color }) => theme[color]};
      font-weight: 600;
      font-size: 16px;
      line-height: 20px;
      display: flex;
      align-items: center;
      flex-direction: row;
      cursor: pointer;

      ${({ direction = `right` }) => (direction === `right` ? `&:after` : `&:before`)} {
        content: "";
        width: 12px;
        height: 12px;
        background: url("${({ color }) => require(`assets/icons/arrow-right-${color}.svg`)}") no-repeat center center / contain;
        margin-left: 8px;
        transition: 0.2s;

        ${({ direction = `right` }) =>
                direction === `left` &&
                css`
                  transform: rotate(180deg);
                  margin-left: unset;
                  margin-right: 8px;
                `}
      }

      &:hover {
        ${({ direction = `right` }) => (direction === `right` ? `&:after` : `&:before`)} {
          transform: translateX(${({ direction = `right` }) => (direction === `right` ? 3 : -3)}px) ${({ direction = `right` }) => (direction === `left` ? `rotate(180deg)` : ``)};
        }
      }
    `,
    DetailsWrapper: styled(RowWrapper)`
      > * {
        margin-bottom: 8px;
        width: 100%;

        p {
          margin-bottom: 8px;
        }
      }

      @media (max-width: 991px) {
        flex-wrap: wrap;
        > * {
          width: 50%;
        }
      };
    `
};

const EventName = styled.div``;

const EventDetails = styled.div``;

const EventTop = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const EventItem = styled.div`
  padding: 5px;
  box-sizing: border-box;
  margin-bottom: 5px;
  border: 1px solid lightgrey;
  margin-bottom: 5px;
`;

const TableWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
`;

const MyTable = styled.table`
  border-collapse: collapse;
  border: 1px solid lightgrey;
`;

const MyTr = styled.tr`
  :hover {
    background: lightgoldenrodyellow;
  }
`;

const MyTd = styled.td`
  border: 1px solid lightgrey;
  text-align: center;
  background: ${(props) => (props.color == undefined ? "white" : props.color)};
`;

const DatesSpanHead = styled.th`
  text-align: center;
  white-space: nowrap;
  font-size: 10px;
  border: 1px solid lightgrey;
`;

const UniRow = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  :hover {
    background: whitesmoke;
  }
`;

export default AdminQuestionnairesPage;
